import React, { useState } from "react";
import DailyLogWitnessManager from "./dailyLogFormsManager/daily-log-witness-manager";
import BehaviorSelectionManager from "./dailyLogFormsManager/behavioural-select-manager";
import ChallengingBehaviorManager from "./dailyLogFormsManager/challenging-behaviour-manager";
import DeescalationStrategiesManger from "./dailyLogFormsManager/de-escalation-strategy-manager";
import PhysicalInterventionManager from "./dailyLogFormsManager/physical-intervension-manager";
import VerbalWarningManager from "./dailyLogFormsManager/verbal-warning-manger";

const DailyLogIncidentManager = ({ task, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const nextStep = () => setCurrentStep((prev) => prev + 1);
  const prevStep = () => setCurrentStep((prev) => prev - 1);

  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return <DailyLogWitnessManager witnessData={task?.witnessInfo} nextStep={nextStep} />;
      case 1:
        return (
          <BehaviorSelectionManager behaviourData={task?.behaviouralInfo} nextStep={nextStep} prevStep={prevStep} />
        );
      case 2:
        return (
          <ChallengingBehaviorManager
            challengingData={task?.challengingInfo}
            temperature={task?.temperature}
            sound={task?.sound}
            whoWasAround={task?.whoWasAround}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        );
      case 3:
        return (
          <DeescalationStrategiesManger strategyData={task?.strategyInfo} nextStep={nextStep} prevStep={prevStep} />
        );
      case 4:
        return (
          <PhysicalInterventionManager physicalData={task?.physicalInfo} nextStep={nextStep} prevStep={prevStep} />
        );
      case 5:
        return (
          <VerbalWarningManager
            verbalData={task?.verbalWarningInfo}
            clearVerbal={task?.warningGiven}
            prevStep={prevStep}
            handleSubmit={onClose}
          />
        );
      default:
        return null;
    }
  };

  return <div>{renderForm()}</div>;
};

export default DailyLogIncidentManager;
